import React from 'react'
import Scrollchor from 'react-scrollchor'

const LOCALES = {
  title: {
    de: 'So hat Ihre Gemeinde abgestimmt',
    fr: 'Voici ce que votre commune a voté'
  },
  lead: {
    de: (
      <>
        Erfahren Sie, wie man in Ihrer Gemeinde entschieden hat – auf
        nationaler, kantonaler und kommunaler Ebene. Wie der Service
        funktioniert, <Scrollchor to='#methodik'>lesen Sie hier</Scrollchor>.
      </>
    ),
    fr: (
      <>
        Découvrez comment votre commune a voté, tant au niveau fédéral, cantonal
        que communal. Le mode de fonctionnement de ce service est{' '}
        <Scrollchor to='#methodik'>expliqué ici</Scrollchor>.
      </>
    )
  },
  searchLabel: {
    de: 'Suchen Sie nach einer anderen Postleitzahl oder Gemeindenamen',
    fr: 'Cherchez par code postal ou par localité'
  },
  boxTitle: {
    de: 'Für Sie generierten wir folgenden Artikel',
    fr: 'Nous avons généré cet article pour vous'
  },
  signature: {
    de: 'Edgar Schuler und Patrice Siegrist, mit Textroboter Tobi',
    fr: 'Mathieu Signorell avec l’aide du robot Tobi'
  },
  municipalitySearchBoxTitle: {
    de: 'Eine andere Gemeinde anzeigen',
    fr: 'Cherchez une autre commune'
  },
  dashboardPrefix: { de: 'abstimmungen', fr: 'votations' },
  dashboardButton: {
    de: 'Zur Abstimmungsübersicht',
    fr: "Vers l'aperçu des votes"
  },
  votationLink: {
    de: 'Die Resultate in Karten',
    fr: 'Tous les résultats et toutes les cartes en détail'
  },
  votationLinkSup: {
    de: 'So stimmte die Schweiz',
    fr: 'Votations d\'aujourd\'hui'
  },
  gotoCanton: {
    de: 'Zu den kantonalen Ergebnissen',
    fr: 'Voir les résultats cantonaux'
  },
  communalVotesTitle: {
    de: 'Kommunale Abstimmungen',
    fr: 'Résultats communaux'
  },
  gotoFederal: {
    de: 'Zu den eidgenössischen Ergebnissen',
    fr: 'Voir les résultats fédérales'
  }
}

export default LOCALES
